
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './mixed-conditionals-explanation';
const mainimage = '/Images/mixedcond1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "grammar", subtype: "mixed-cond-prod" },
];

const MixedCondProd = () => (
  <GrammarPageLayout
    level="B1"
    title="Mixed Cond Prod"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Mixed Conditional Grammar Practice"
    seoDescription="Combine different time references in mixed conditional sentences. B2 level advanced practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default MixedCondProd;

